import React, {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {Campaigns} from '../pages/agency/campaigns'
import {ReportOffers} from '../pages/agency/reportOffers'
import {Offers} from '../pages/agency/offers'
import {Creatives} from '../pages/agency/creatives'
import {ChannelOffers} from '../pages/publisher/channelOffers'
import AgencyReports from '../pages/agency/reports'
import {Trailers} from '../pages/publisher/trailers'
import Schedule from '../pages/publisher/schedule'
import PublisherReports from '../pages/publisher/report'
import ChannelRerports from '../pages/publisher/channelReports'
import {OfferEdit} from '../pages/agency/offerEdit'
import {UserContext} from '../contexts/auth'
import ChangePassword from '../pages/changePassword'
import ChannelOfferDetail from '../pages/publisher/channelOfferDetail'
import OfferDetail from '../pages/agency/offerDetail'

const PrivateRoutes = () => {
  const userDetails = React.useContext(UserContext)

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        {userDetails.pubId && <Route path='dashboard' element={<DashboardWrapper />} />}

        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        <Route path='change-password' element={<ChangePassword />} />
        {/* Publishers */}
        <Route path='publishers/:publisher_id/schedule' element={<Schedule />} />
        <Route path='publishers/:publisher_id/channel-offers' element={<ChannelOffers />} />
        <Route
          path='publishers/:publisher_id/channels/:channel_id/offers/:offer_id'
          element={<ChannelOfferDetail />}
        />
        <Route path='publishers/:publisher_id/trailers' element={<Trailers />} />
        <Route path='publishers/:publisher_id/reports' element={<PublisherReports />} />
        <Route path='publishers/:publisher_id/channelReports' element={<ChannelRerports />} />
        {/* Agencies */}
        <Route path='agencies/:agency_id/campaigns' element={<Campaigns />} />
        <Route path='agencies/:agency_id/offers' element={<Offers />} />
        <Route path='agencies/:agency_id/offers/:offer_id' element={<OfferDetail />} />
        <Route path='agencies/:agency_id/offers/:offer_id/edit' element={<OfferEdit />} />
        <Route path='agencies/:agency_id/report/offers' element={<ReportOffers />} />
        <Route path='agencies/:agency_id/creatives' element={<Creatives />} />
        <Route path='agencies/:agency_id/reports' element={<AgencyReports />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      0: baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
